import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ertigacabbookinginpune() {



  const cardData = {


  keyword: "Ertiga Cab Booking in Pune",

  headingDescription: "Trustline Cab provides reliable Ertiga cab booking services in Pune with comfortable, spacious, and affordable transportation for family trips, corporate travel, airport transfers, local sightseeing, outstation journeys, and group travel. Maruti Ertiga is an ideal choice for passengers looking for a budget-friendly 7-seater cab with comfortable seating, ample luggage space, and a smooth travel experience. Whether you need an Ertiga for Pune local travel, Mumbai trips, airport pickup and drop, one-way taxi, round trip, or multi-day rental, our professional chauffeurs ensure safe and convenient journeys. With transparent pricing, doorstep pickup, easy online booking, experienced drivers, well-maintained vehicles, flexible rental packages, and 24/7 customer support, Trustline Travels is your trusted choice for Ertiga cab booking in Pune. Ertiga cab options are commonly available for Pune local and outstation travel requirements through various online cab booking services. :contentReference[oaicite:1]{index=1}",

  topPlaces: [
    {
      title: "Mumbai Airport",
      description: "Mumbai Airport is a major travel destination for Pune passengers requiring comfortable airport transfers. Ertiga cabs are preferred by families and small groups traveling with luggage between Pune and Mumbai Airport."
    },
    {
      title: "Bandra",
      description: "Bandra is one of Mumbai's premium locations known for corporate offices, shopping destinations, restaurants, and entertainment hubs. It is a popular destination for Pune to Mumbai Ertiga cab bookings."
    },
    {
      title: "Hinjewadi IT Park",
      description: "Hinjewadi IT Park is Pune's largest technology hub, featuring multinational companies, IT offices, and corporate campuses. Ertiga cabs are suitable for employee transportation and business travel."
    },
    {
      title: "Kharadi",
      description: "Kharadi is a major IT and commercial area in Pune, home to EON IT Park, corporate offices, hotels, and business centers. It is a preferred location for professionals requiring comfortable cab services."
    },
    {
      title: "Pimpri Chinchwad",
      description: "Pimpri Chinchwad is a major industrial and commercial region known for automobile companies, manufacturing units, engineering industries, and corporate establishments."
    },
    {
      title: "Navi Mumbai",
      description: "Navi Mumbai is a developing commercial hub with corporate offices, industrial areas, residential projects, and modern infrastructure. It is a popular outstation destination from Pune."
    },
    {
      title: "Lonavala",
      description: "Lonavala is a scenic hill station between Mumbai and Pune, famous for waterfalls, viewpoints, caves, and green valleys. Ertiga rental is a comfortable option for family and group trips."
    },
    {
      title: "Mahabaleshwar",
      description: "Mahabaleshwar is a beautiful hill station near Pune known for strawberry farms, viewpoints, lakes, waterfalls, and pleasant weather. It is a popular weekend destination for travelers."
    },
    {
      title: "Alibaug",
      description: "Alibaug is a coastal getaway near Mumbai famous for beaches, forts, and relaxing vacations. It is a preferred outstation destination for families and groups traveling from Pune."
    },
    {
      title: "Lavasa",
      description: "Lavasa is a planned hill city near Pune offering lakeside views, scenic roads, adventure activities, and peaceful surroundings. It is a popular destination for weekend trips and sightseeing."
    }
  ],






"services": [
  {
    "name": "Ertiga Rent Per Km in Pune",
    "description": "Check Ertiga Rent Per Km in Pune with transparent pricing, affordable packages, comfortable 7-seater vehicles, professional chauffeurs, and flexible rental options for local and outstation travel."
  },
  {
    "name": "Ertiga Cab Booking in Pune",
    "description": "Book Ertiga Cab Booking in Pune for family trips, airport transfers, corporate travel, and outstation journeys with clean AC vehicles, experienced drivers, and reliable service."
  },
  {
    "name": "Book Ertiga Car in Pune",
    "description": "Book Ertiga Car in Pune for comfortable travel with spacious seating, luggage space, professional chauffeurs, fixed fares, and convenient pickup locations."
  },
  {
    "name": "Pune to Outstation Ertiga Cab",
    "description": "Reserve Pune to Outstation Ertiga Cab for long-distance travel with affordable pricing, AC comfort, experienced drivers, and safe highway journeys."
  },
  {
    "name": "New Ertiga Cab Booking in Pune",
    "description": "Choose New Ertiga Cab Booking in Pune with well-maintained vehicles, professional chauffeurs, online booking facility, and comfortable travel solutions."
  },
  {
    "name": "New Ertiga Cab Booking in Pune Contact Number",
    "description": "Contact New Ertiga Cab Booking in Pune for instant reservations, fare details, vehicle availability, and reliable cab services with professional support."
  },
  {
    "name": "New Ertiga Cab Booking in Pune Contact Number Hadapsar",
    "description": "Book New Ertiga Cab from Hadapsar Pune with doorstep pickup, affordable fares, experienced drivers, and comfortable 7-seater transportation."
  },
  {
    "name": "Ertiga Cab Booking in Kharadi",
    "description": "Reserve Ertiga Cab Booking in Kharadi for airport transfers, office travel, family trips, and outstation journeys with premium comfort and reliable service."
  },
  {
    "name": "Ertiga Cab Booking in Hinjewadi",
    "description": "Book Ertiga Cab Booking in Hinjewadi for corporate travel, IT park transportation, airport rides, and outstation trips with professional chauffeurs."
  },
  {
    "name": "Pune to Mahabaleshwar Ertiga Cab",
    "description": "Travel from Pune to Mahabaleshwar with Ertiga Cab offering comfortable seating, experienced drivers, affordable fares, and safe hill station travel."
  },
  {
    "name": "7 Seater Car on Rent in Pune",
    "description": "Hire 7 Seater Car on Rent in Pune for family vacations, group travel, airport transfers, and outstation journeys with spacious and comfortable vehicles."
  },
  {
    "name": "8 Seater Car on Rent in Pune",
    "description": "Book 8 Seater Car on Rent in Pune for group transportation with comfortable seating, professional drivers, AC vehicles, and flexible rental options."
  },
  {
    "name": "Ertiga Cab Booking in Baner Aundh",
    "description": "Reserve Ertiga Cab Booking in Baner Aundh for local rides, corporate travel, airport transfers, and outstation trips with reliable chauffeur service."
  },
  {
    "name": "Ertiga Car on Rent in Pune",
    "description": "Hire Ertiga Car on Rent in Pune for personal travel, business trips, family tours, and long-distance journeys with affordable rental packages."
  },
  {
    "name": "Pune Darshan Ertiga Cab Booking in Pune",
    "description": "Book Pune Darshan Ertiga Cab for city sightseeing with comfortable seating, professional drivers, flexible timings, and convenient travel experience."
  },
  {
    "name": "Ertiga Cab Rentals in Pune",
    "description": "Choose Ertiga Cab Rentals in Pune for local and outstation travel with clean vehicles, experienced chauffeurs, affordable fares, and easy booking."
  },
  {
    "name": "Cab for Outstation Journey",
    "description": "Book Cab for Outstation Journey with comfortable Ertiga vehicles, professional drivers, transparent pricing, and reliable long-distance transportation."
  },
  {
    "name": "Hire Ertiga Cab for Outstation",
    "description": "Hire Ertiga Cab for Outstation trips with spacious seating, AC comfort, experienced chauffeurs, and safe travel across destinations."
  },
  {
    "name": "Velocity Cabs",
    "description": "Velocity Cabs provides reliable Ertiga cab services in Pune with professional drivers, comfortable vehicles, airport transfers, and outstation travel solutions."
  },
  {
    "name": "Ertiga Cab Booking in Pune",
    "description": "Book Ertiga Cab Booking in Pune for affordable and comfortable transportation with experienced chauffeurs, clean vehicles, and flexible travel options."
  },
  {
    "name": "Ertiga Cab in Pune",
    "description": "Choose Ertiga Cab in Pune for family trips, airport pickup, corporate travel, and outstation journeys with reliable service and comfortable seating."
  },
  {
    "name": "Ertiga on Rent in Pune",
    "description": "Rent Ertiga on Rent in Pune with driver for local and outstation travel featuring affordable rates, spacious interiors, and professional chauffeur service."
  },
  {
    "name": "Ertiga Taxi Service Pune",
    "description": "Book Ertiga Taxi Service Pune for safe travel with premium 7-seater cars, experienced drivers, transparent pricing, and 24x7 availability."
  },
  {
    "name": "Maruti Ertiga Cab Hire Pune",
    "description": "Hire Maruti Ertiga Cab in Pune for comfortable family travel, business trips, airport transfers, and outstation transportation."
  },
  {
    "name": "Book Ertiga Cab Pune",
    "description": "Book Ertiga Cab Pune online with instant confirmation, clean AC vehicles, professional drivers, and affordable travel packages."
  },
  {
    "name": "Ertiga Car Rental Pune",
    "description": "Choose Ertiga Car Rental Pune for flexible rental plans, comfortable seating, experienced chauffeurs, and reliable transportation."
  },
  {
    "name": "Ertiga Taxi Booking Pune",
    "description": "Complete Ertiga Taxi Booking Pune for airport rides, local travel, corporate trips, and outstation journeys with easy online booking."
  },
  {
    "name": "7 Seater Ertiga Cab Pune",
    "description": "Book 7 Seater Ertiga Cab Pune for family vacations, group travel, and comfortable long-distance journeys with professional drivers."
  },
  {
    "name": "Cheap Ertiga Cab Pune",
    "description": "Hire Cheap Ertiga Cab Pune with affordable fares, clean vehicles, experienced chauffeurs, and reliable transportation services."
  },
  {
    "name": "Ertiga Cab Service Pune",
    "description": "Choose Ertiga Cab Service Pune for safe and comfortable travel with AC vehicles, professional drivers, flexible booking, and dependable customer support."
  }
],

"tableData": [
  ["Ertiga Rent Per Km in Pune", "Ertiga Cab Booking in Pune"],
  ["Book Ertiga Car in Pune", "Pune to Outstation Ertiga Cab"],
  ["New Ertiga Cab Booking in Pune", "New Ertiga Cab Booking in Pune Contact Number"],
  ["New Ertiga Cab Booking in Pune Contact Number Hadapsar", "Ertiga Cab Booking in Kharadi"],
  ["Ertiga Cab Booking in Hinjewadi", "Pune to Mahabaleshwar Ertiga Cab"],
  ["7 Seater Car on Rent in Pune", "8 Seater Car on Rent in Pune"],
  ["Ertiga Cab Booking in Baner Aundh", "Ertiga Car on Rent in Pune"],
  ["Pune Darshan Ertiga Cab Booking in Pune", "Ertiga Cab Rentals in Pune"],
  ["Cab for Outstation Journey", "Hire Ertiga Cab for Outstation"],
  ["Velocity Cabs", "Ertiga Cab Booking in Pune"],
  ["Ertiga Cab in Pune", "Ertiga on Rent in Pune"],
  ["Ertiga Taxi Service Pune", "Maruti Ertiga Cab Hire Pune"],
  ["Book Ertiga Cab Pune", "Ertiga Car Rental Pune"],
  ["Ertiga Taxi Booking Pune", "7 Seater Ertiga Cab Pune"],
  ["Cheap Ertiga Cab Pune", "Ertiga Cab Service Pune"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Ertiga Cab Booking in Pune",
    WhyChoosedescription: "Trustline Cab provides comfortable Ertiga cab booking services in Pune with professional drivers, well-maintained vehicles, and reliable travel solutions for every journey."
  },
  {
    WhyChooseheading: "Spacious Ertiga for Family & Group Travel",
    WhyChoosedescription: "Maruti Ertiga offers comfortable seating, extra luggage space, and a smooth ride, making it ideal for families, airport transfers, and group travel."
  },
  {
    WhyChooseheading: "Pickup Available Across Pune",
    WhyChoosedescription: "Get convenient Ertiga pickup from Pune Airport, railway station, Hinjewadi, Wakad, Baner, Kharadi, Viman Nagar, Pimpri Chinchwad, and other locations."
  },
  {
    WhyChooseheading: "Professional Chauffeur Driven Service",
    WhyChoosedescription: "Our experienced drivers ensure safe, punctual, and comfortable travel with excellent knowledge of Pune city and outstation routes."
  },
  {
    WhyChooseheading: "Affordable Ertiga Rental Options",
    WhyChoosedescription: "Book Ertiga for local travel, airport transfers, one-way trips, round trips, and outstation journeys with transparent pricing."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "All Ertiga cabs are regularly serviced and maintained to provide a hygienic, comfortable, and stress-free travel experience."
  },
  {
    WhyChooseheading: "Perfect for Corporate & Personal Trips",
    WhyChoosedescription: "Ertiga cab service is suitable for office travel, business meetings, family outings, sightseeing, and long-distance journeys."
  },
  {
    WhyChooseheading: "24/7 Ertiga Cab Booking Support",
    WhyChoosedescription: "Book your Ertiga cab in Pune anytime with quick confirmation and dedicated customer assistance."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Ertiga cab booking in Pune?",
    answer: "Yes, Trustline Travels offers Ertiga cab booking services in Pune for local travel, airport transfers, outstation trips, and corporate requirements."
  },
  {
    question: "Can I book an Ertiga cab with a driver in Pune?",
    answer: "Yes, chauffeur-driven Ertiga cabs are available for comfortable and safe travel across Pune and nearby destinations."
  },
  {
    question: "How many passengers can travel in an Ertiga cab?",
    answer: "Ertiga is suitable for family and group travel with comfortable seating capacity along with luggage space."
  },
  {
    question: "Where can I get Ertiga pickup in Pune?",
    answer: "Pickup is available from Pune Airport, railway station, offices, hotels, residential areas, and major locations across Pune."
  },
  {
    question: "Can I book Ertiga for outstation trips from Pune?",
    answer: "Yes, Ertiga cabs are available for destinations like Mumbai, Lonavala, Mahabaleshwar, Nashik, Shirdi, and other outstation locations."
  },
  {
    question: "Is Ertiga cab booking available 24 hours in Pune?",
    answer: "Yes, Ertiga cab booking services are available 24/7 according to your travel requirements."
  },
  {
    question: "Can I hire Ertiga for airport pickup and drop?",
    answer: "Yes, Ertiga cabs are available for Pune Airport pickup, drop, and airport transfer services."
  },
  {
    question: "Are toll and parking charges included in the Ertiga cab fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless mentioned in the confirmed quotation."
  },
  {
    question: "Do you provide Ertiga cabs for corporate travel?",
    answer: "Yes, our Ertiga cab services are suitable for corporate meetings, employee transportation, client visits, and business travel."
  },
  {
    question: "How can I book Ertiga Cab Booking in Pune with Trustline Travels?",
    answer: "Share your pickup location, destination, travel date, passenger details, and requirements to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Patil",
    feedback: "We booked an Ertiga cab in Pune for a family trip and had a great experience. The vehicle was clean, spacious, and the driver provided excellent service.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priya Sharma",
    feedback: "Trustline Travels provided a comfortable Ertiga with a professional driver. The booking process was easy and the complete journey was smooth and enjoyable.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ertiga Cab Booking in Pune",
  "image": "https://www.trustlinetravels.com/assets/images/ertiga-cab-booking-in-pune.webp",
  "description":
    "Book Ertiga Cab Booking in Pune with Trustline Travels for comfortable, spacious, and affordable taxi services. We provide Ertiga cabs for local, outstation, airport transfers, one-way, and round-trip travel from Pune with professional drivers available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/ertiga-cab-booking-in-pune"
  }
};







  return (
    <div>
<Helmet>
  <title>Ertiga Cab Booking in Pune | 7 Seater Taxi | +91 8087080034</title>

  <meta
    name="description"
    content="Book Ertiga Cab Booking in Pune with Trustline Travels for affordable 6-seater and 7-seater taxi services. Hire Ertiga cabs for local travel, outstation trips, airport transfers, one-way, and round-trip journeys with 24x7 availability."
  />

  <meta
    name="keywords"
    content="Ertiga rent per km in pune, Ertiga cab booking in pune, book ertiga car in pune, pune to outstation ertiga cab, New ertiga cab booking in pune, New ertiga cab booking in pune contact number, New ertiga cab booking in pune contact number hadapsar, ertiga cab booking, Ertiga taxi Pune, 7 seater Ertiga cab Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/13.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ertigacabbookinginpune;